import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {BlankComponent} from '@pages/blank/blank.component';
import {ProfileComponent} from '@pages/profile/profile.component';
import {DashboardComponent} from '@pages/dashboard/dashboard.component';
import {NonAuthGuard} from '@guards/non-auth.guard';
import {SubMenuComponent} from '@pages/main-menu/sub-menu/sub-menu.component';
import {authGuard} from '@guards/auth.guard';
import {UsersComponent} from '@pages/users/users.component';
import {EmailSettingComponent} from '@pages/email-setting/email-setting.component';
import {VerifyOTPResetpasswordComponent} from '@modules/verify-otp-resetpassword/verify-otp-resetpassword.component';
import {AddSupplierComponent} from '@pages/supplier/add-supplier/add-supplier.component';
import {FarmComponent} from '@pages/farm/farm/farm.component';
import {AddPlacementComponent} from '@pages/placement/add-placement/add-placement.component';
import {PlacementListComponent} from '@pages/placement/placement-list/placement-list.component';
import {AddMedicationComponent} from '@pages/medication/add-medication/add-medication.component';
import {MedicationListComponent} from '@pages/medication/medication-list/medication-list.component';
import {AddDisinfectionComponent} from '@pages/disinfection/add-disinfection/add-disinfection.component';
import {DisinfectionListComponent} from '@pages/disinfection/disinfection-list/disinfection-list.component';
import {DisinfectionPanelComponent} from '@pages/disinfection/disinfection-panel/disinfection-panel.component';
import {NotificationsListComponent} from '@pages/notifications-list/notifications-list.component';
import {EditDisinfectionComponent} from '@pages/disinfection/edit-disinfection/edit-disinfection.component';
import {PlacementDetailComponent} from '@pages/placement-detail/placement-detail.component';
import {UserPermissionComponent} from '@pages/user-permission/user-permission.component';
import {UserPermissionListComponent} from '@pages/user-permission/user-permission-list/user-permission-list.component';
import {EditUserPermissionComponent} from '@pages/user-permission/edit-user-permission/edit-user-permission.component';
import {FarmUserListComponent} from '@pages/farm-user/farm-user-list/farm-user-list.component';
import {AddFarmUserComponent} from '@pages/farm-user/add-farm-user/add-farm-user.component';
import {EditFarmComponent} from '@pages/farm/edit-farm/edit-farm.component';
import {FarmDetailComponent} from '@pages/farm/farm-detail/farm-detail.component';
import {ForecastComponent} from '@pages/forecast/forecast.component';
import {EditMedicationComponent} from '@pages/medication/edit-medication/edit-medication.component';
import {MedicationDetailComponent} from '@pages/medication/medication-detail/medication-detail.component';
import {EditFarmUserComponent} from '@pages/farm-user/edit-farm-user/edit-farm-user.component';
import {OnboardingComponent} from '@components/onboarding/onboarding.component';
import {VaccineListComponent} from '@pages/vaccine/vaccine-list/vaccine-list.component';
import {AddVaccineComponent} from '@pages/vaccine/add-vaccine/add-vaccine.component';
import {EditVaccineComponent} from '@pages/vaccine/edit-vaccine/edit-vaccine.component';
import {VaccineDetailComponent} from '@pages/vaccine/vaccine-detail/vaccine-detail.component';
import {AuditLogComponent} from '@pages/auditlog/audit-log/audit-log.component';
import {AudtilogDetailComponent} from '@pages/auditlog/audtilog-detail/audtilog-detail.component';
import {MedicationPanelComponent} from '@pages/medication/medication-panel/medication-panel.component';
import {FarmsListComponent} from '@pages/farm/farms-list/farms-list.component';
import {TasksListComponent} from '@pages/tasks-list/tasks-list.component';
import {HouseDetailsOverviewComponent} from '@components/dashboard/house-details-overview/house-details-overview.component';
import {DisinfectionDetailComponent} from '@pages/disinfection/disinfection-detail/disinfection-detail.component';
import {UserProfileSettingsComponent} from '@pages/settings/user-profile-settings/user-profile-settings.component';
import {LanguageTimeZoneComponent} from '@pages/settings/language-time-zone/language-time-zone.component';
import {CompanyInformationComponent} from '@pages/settings/company-information/company-information.component';
import {SmartPoultryInfoLegalComponent} from '@pages/settings/smart-poultry-info-legal/smart-poultry-info-legal.component';
import {DeviceConfigurationComponent} from '@pages/settings/device-configuration/device-configuration.component';
import {isAdminGuard} from '@guards/is-admin.guard';
import {isTopManagementGuard} from '@guards/is-top-management.guard';
import {RoleGuard} from '@guards/role.guard';
import {MainComponent} from './core/main.component';
import {SuperAdminMainComponentComponent} from './core/super-admin-main-component/super-admin-main-component.component';
import { PurchaseCallbackComponent } from './components/purchase-callback/purchase-callback.component';
import { PowerBiDashboardComponent } from '@pages/powerbi-dashboard/powerbi-dashboard.component';
const routes: Routes = [
    {
        path: '',
        component: MainComponent,
        canActivate: [authGuard],
        children: [
            {
                path: 'power-bi',
                component: PowerBiDashboardComponent
            },
            {
                path: 'addSupplier',
                component: AddSupplierComponent
            },
            {
                path: 'profile',

                component: ProfileComponent
            },
            {
                path: 'Users',

                component: UsersComponent
            },
            {
                path: 'EmailSetting',

                component: EmailSettingComponent
            },
            {
                path: 'sub-menu-1',
                component: SubMenuComponent
            },
            {
                path: 'sub-menu-2',
                component: BlankComponent
            },
            {
                path: '',
                component: DashboardComponent
            },
            {
                path: 'house-detail/:id',
                component: HouseDetailsOverviewComponent
            },
            {
                path: 'add-farm',
                component: FarmComponent
            },
            {
                path: 'farms-information',
                component: FarmsListComponent,
                canActivate: [RoleGuard],
                data: {roles: ['Admin', 'Top Management']}
            },
            {
                path: 'farm-detail/:id',
                component: FarmDetailComponent
            },
            {
                path: 'add-placement',
                component: AddPlacementComponent
            },
            {
                path: 'add-placement/:id',
                component: AddPlacementComponent
            },
            {
                path: 'placement-detail/:id',
                component: PlacementDetailComponent
            },

            {
                path: 'placement',
                component: PlacementListComponent
            },
            {
                path: 'add-medication',
                component: AddMedicationComponent
            },
            {
                path: 'medication-list',
                component: MedicationListComponent
            },
            {
                path: 'medication-panel',
                component: MedicationPanelComponent
            },

            {
                path: 'edit-medication/:id',
                component: EditMedicationComponent
            },
            {
                path: 'medication-detail/:id',
                component: MedicationDetailComponent
            },
            {
                path: 'add-disinfection',
                component: AddDisinfectionComponent
            },
            {
                path: 'edit-disinfection/:id',
                component: EditDisinfectionComponent
            },

            {
                path: 'disinfection-list',
                component: DisinfectionListComponent
            },
            {
                path: 'disinfection-panel',
                component: DisinfectionPanelComponent
            },
            {
                path: 'disinfection-detail/:id',
                component: DisinfectionDetailComponent
            },
            {
                path: 'notification-list',
                component: NotificationsListComponent
            },
            {
                path: 'user-permission',
                component: UserPermissionComponent
            },
            {
                path: 'user-permission-list',
                component: UserPermissionListComponent
            },
            {
                path: 'edit-role/:id',
                component: EditUserPermissionComponent
            },
            {
                path: 'edit-farm/:id',
                component: EditFarmComponent
            },
            {
                path: 'farm-detail/:id',
                component: FarmDetailComponent
            },
            {
                path: 'farm-user-list',
                component: FarmUserListComponent
            },
            {
                path: 'add-farm-user',
                component: AddFarmUserComponent
            },
            {
                path: 'edit-user/:id',
                component: EditFarmUserComponent
            },
            {
                path: 'fore-cast',
                component: ForecastComponent
            },
            {
                path: 'audit-log',
                component: AuditLogComponent
            },
            {
                path: 'audilog-detail/:id',
                component: AudtilogDetailComponent
            },
            {
                path: 'add-vaccine',
                component: AddVaccineComponent
            },
            {
                path: 'vaccine-list',
                component: VaccineListComponent
            },
            {
                path: 'edit-vaccine/:id',
                component: EditVaccineComponent
            },
            {
                path: 'vaccine-detail/:id',
                component: VaccineDetailComponent
            },
            {
                path: 'task-list',
                component: TasksListComponent
            },
            {
                path: 'user-settings',
                component: UserProfileSettingsComponent
            },
            // {
            //     path: 'lang-timezone-settings',
            //     component: LanguageTimeZoneComponent
            // },
            {
                path: 'company-information-settings',
                component: CompanyInformationComponent
            },
            {
                path: 'smartPoultry-legal-info',
                component: SmartPoultryInfoLegalComponent
            },
            {
                path: 'device-configuration-settings',
                component: DeviceConfigurationComponent,
                canActivate: [isAdminGuard]
            }
        ]
    },

    {
        path: 'login',
        loadChildren: () =>
            import('./modules/login/login.module').then((m) => m.LoginModule)
    },
    {
        path: 'onboarding',
        component: OnboardingComponent,
        canActivate: [NonAuthGuard]
    },
    
    {
        path: 'purchase-callback',
        component: PurchaseCallbackComponent,
        canActivate: [NonAuthGuard]
    },
    {
        path: 'admin-login',
        loadComponent: () =>
            import(
                './modules/superadmin-login/superadmin-login.component'
            ).then((m) => m.SuperadminLoginComponent)
    },
    {
        path: 'veryfyOtp',
        loadChildren: () =>
            import('./modules/verify-otp/verify-otp.module').then(
                (m) => m.VerifyOtpModule
            )
    },
    {
        path: 'resetpassword-OTP',
        loadChildren: () =>
            import(
                './modules/verify-otp-resetpassword/verify-otp-resetpassword-routing.module'
            ).then((m) => m.VerifyOtpResetPasswordRoutingModule)
    },
    {
        path: 'register',
        loadChildren: () =>
            import('./modules/register/register.module').then(
                (m) => m.RegisterModule
            )
    },
    {
        path: 'forgot-password',
        loadChildren: () =>
            import('./modules/forgot-password/forgot-password.module').then(
                (m) => m.ForgotPasswordModule
            ),
        canActivate: [NonAuthGuard]
    },
    {
        path: 'recover-password',
        loadChildren: () =>
            import('./modules/recover-password/recover-password.module').then(
                (m) => m.RecoverPasswordModule
            ),
        canActivate: [NonAuthGuard]
    },
    {
        path: 'admin-dashboard',
        component: SuperAdminMainComponentComponent,
        canActivate: [authGuard]
    },

    {
        path: 'legal-terms',
        loadComponent: () =>
            import('./modules/legal/legal.component').then(
                (m) => m.LegalComponent
            ),
        canActivate: [NonAuthGuard]
    },

    {path: '**', redirectTo: ''}
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled'
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {}
